import BackendConnector from './backendConnector';

export default class OfficeHttpService {
    static getAllOffices() {
        return BackendConnector.get('office');
    }
}
